import React, { useState, useEffect } from "react";
import { 
    Button, FormControl, InputLabel, MenuItem, Select, 
    Card, CardContent, Typography, Box, Snackbar, Alert, 
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox 
} from "@mui/material";
import { db } from "../../firebaseConfig.js";
import { collection, getDocs } from "firebase/firestore";
import axios from "axios";
import JSZip from "jszip";

const PayslipZip = ({ selectedEmployees }) => {
    const [selectedDate, setSelectedDate] = useState({
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1
    });
    const [employees, setEmployees] = useState([]);

    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("info");
    const [selectAll, setSelectAll] = useState(false);
    const [missingEmployees, setMissingEmployees] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    
    const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
    useEffect(() => {
        const fetchEmployees = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "tbl_employee_personal_details"));
                const employeeList = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    name: doc.data().First_Name,
                    email: doc.data().Corporate_Email_ID
                }));
                setEmployees(employeeList);
            } catch (error) {
                console.error("Error fetching employees:", error);
            }
        };
        fetchEmployees();
    }, []);

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setSelectedDate(prev => ({
            ...prev,
            [name]: parseInt(value)
        }));
    };
    const handleDownloadZip = async (excludedEmployees = []) => {
        excludedEmployees = Array.isArray(excludedEmployees) ? excludedEmployees : [];
    
        if (!selectedEmployees || selectedEmployees.length === 0) {
            setSnackbarMessage("Please select at least one employee before downloading.");
            setSnackbarSeverity("warning");
            setSnackbarOpen(true);
            return;
        }
    
        try {
            let filteredEmployees = selectedEmployees.filter(emp => !excludedEmployees.includes(emp));
    
            if (filteredEmployees.length === 0) {
                setSnackbarMessage("No available payslips for selected employees.");
                setSnackbarSeverity("warning");
                setSnackbarOpen(true);
                return;
            }
    
            const employeeParam = filteredEmployees.length === employees.length ? "all" : filteredEmployees.join(",");
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL_HRM}/download_payslip_zip?month=${selectedDate.month}&year=${selectedDate.year}&employees=${employeeParam}`,
                {
                  responseType: "blob",
                  validateStatus: () => true,
                  headers: {
                    Authorization: `Bearer ${accessToken}`
                  }
                }
              );
    
            if (response.status === 206) {
                // Handle partial content (some missing payslips)
                const reader = new FileReader();
                reader.onload = function () {
                    try {
                        const jsonData = JSON.parse(reader.result);
                        const missingList = jsonData.missing_employees.map(emp => `${emp.name} (${emp.email})`).join("\n");
    
                        if (jsonData.missing_employees.length === filteredEmployees.length) {
                            setSnackbarMessage("No payslips found for the selected employees.");
                            setSnackbarSeverity("warning");
                            setSnackbarOpen(true);
                            return;
                        }
    
                        // Ask the user if they want to proceed with available ones
                        const userConfirmed = window.confirm(
                            `Payslips not found for the following employees:\n\n${missingList}\n\nDo you want to proceed with the available ones?`
                        );
    
                        if (userConfirmed) {
                            // Recursively call the function, excluding missing employees
                            handleDownloadZip([...excludedEmployees, ...jsonData.missing_employees.map(emp => emp.id)]);
                        } else {
                            setSnackbarMessage("Download cancelled.");
                            setSnackbarSeverity("info");
                            setSnackbarOpen(true);
                        }
    
                    } catch (err) {
                        console.error("Failed to parse JSON response:", err);
                    }
                };
                reader.readAsText(response.data);
                return;
            }
    
            if (response.status === 404) {
                setSnackbarMessage("No payslips found for the selected employees.");
                setSnackbarSeverity("warning");
                setSnackbarOpen(true);
                return;
            }
    
            // Proceed with downloading the ZIP file
            const zipBlob = new Blob([response.data], { type: "application/zip" });
            const url = window.URL.createObjectURL(zipBlob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `payslips_${selectedDate.year}_${selectedDate.month}.zip`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
            setSnackbarMessage("Payslip ZIP downloaded successfully!");
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
    
        } catch (error) {
            console.error("Error downloading ZIP:", error);
            setSnackbarMessage("Error downloading payslips. Please try again.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
    };
    
    
    
    return (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            {/* <Card sx={{ width: 600, padding: 4, boxShadow: 5, borderRadius: 4 }}> */}
                <CardContent>
                    <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel>Month</InputLabel>
                            <Select name="month" value={selectedDate.month} onChange={handleDateChange} label="Month">
                                {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                                    <MenuItem key={month} value={month}>
                                        {new Date(2000, month - 1, 1).toLocaleString("en-US", { month: "long" })}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel>Year</InputLabel>
                            <Select name="year" value={selectedDate.year} onChange={handleDateChange} label="Year">
                                {Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i).map((year) => (
                                    <MenuItem key={year} value={year}>{year}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>

                   

                    <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                        <Button variant="contained" color="primary" onClick={handleDownloadZip} sx={{ width: "100%", borderRadius: 2 }}>
                            Download ZIP
                        </Button>
                    </Box>
                </CardContent>
          

            {/* Snackbar Notification */}
            <Snackbar open={snackbarOpen} autoHideDuration={5000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert severity={snackbarSeverity} onClose={() => setSnackbarOpen(false)}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default PayslipZip;
